// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import EmailManagement from '../components/admin/EmailManagement';
import AdminNewsPanel from '../components/admin/AdminNewsPanel';
// eslint-disable-next-line no-unused-vars
import CouponManagement from '../components/admin/CouponManagement';

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: center;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  justify-content: center;
`;

const ContentContainer = styled.div`
  margin-top: 20px;
  padding: 15px;
  border-radius: 8px;
`;

const Title = styled.h3`
  text-align: center;
`;

const AdminPanel = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [selectedSection, setSelectedSection] = useState(null);
  const [eventOption, setEventOption] = useState(null);

  if (!user || user.permission !== 3) {
    return <Navigate to="/" replace />;
  }

  const sections = {
    news: t('adminPanel.newsPanel'),
    users: t('adminPanel.userManagement'),
    emails: t('adminPanel.sendEmail'),
    logs: t('adminPanel.logsStatistics'),
    shop: t('adminPanel.cashShopManagement'),
    events: t('adminPanel.eventManagement'),
  };

  const eventOptions = {
    coupons: t('adminPanel.manageCoupons'),
    wheel: t('adminPanel.luckyWheelPrizes'),
  };

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('adminPanel.adminPanelTitle')} />

      {/* Button Navigation */}
      <ButtonContainer>
        {Object.entries(sections).map(([key, label]) => (
          <button key={key} onClick={() => setSelectedSection(key)}>
            {label}
          </button>
        ))}
      </ButtonContainer>

      {/* Display selected section */}
      <ContentContainer>
        {selectedSection === 'emails' ? (
          <EmailManagement />
        ) : selectedSection === 'news' ? (
          <AdminNewsPanel />
        ) : selectedSection === 'events' ? (
          <div>
            <Title>{t('adminPanel.eventManagement')}</Title>
            <OptionsContainer>
              {Object.entries(eventOptions).map(([key, label]) => (
                <button key={key} onClick={() => setEventOption(key)}>
                  {label}
                </button>
              ))}
            </OptionsContainer>
            {eventOption ? (
              <p>{t('adminPanel.formFor', { module: eventOptions[eventOption] })}</p>
            ) : null}
          </div>
        ) : selectedSection ? (
          <div>
            <Title>{sections[selectedSection]}</Title>
            <p>{t('adminPanel.moduleMessage', { module: sections[selectedSection] })}</p>
          </div>
        ) : (
          <p>{t('adminPanel.pleaseSelectSection')}</p>
        )}
      </ContentContainer>
    </PageContentComponent>
  );
};

export default AdminPanel;
